/**
 * @fileoverview Bloco de uma página de configurações: título e descrição curta
 * em cima e, embaixo, o cartão com as linhas (SettingItem). O título fica fora
 * do cartão para não se confundir com o título das linhas. `plain` tira o
 * cartão, para conteúdos que já têm os seus (ex.: o horário da semana) e não
 * ficariam "caixa dentro de caixa".
 */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { tokens } from "../Triage/styles";

const useStyles = makeStyles((theme) => {
  const c = tokens(theme.palette.type === "dark");
  return {
    header: { marginBottom: 10 },
    title: {
      margin: 0,
      fontSize: 15,
      fontWeight: 600,
      color: c.textPrimary,
      lineHeight: 1.4,
    },
    description: {
      margin: "2px 0 0",
      fontSize: 12.5,
      color: c.textSecondary,
      lineHeight: 1.5,
    },
    card: {
      background: c.surface,
      border: `1px solid ${c.border}`,
      borderRadius: 12,
    },
  };
});

const SettingsSection = ({ title, description, plain = false, settingId, className, children }) => {
  const classes = useStyles();

  return (
    <section className={className} data-setting-id={settingId}>
      {(title || description) && (
        <div className={classes.header}>
          {title && <h2 className={classes.title}>{title}</h2>}
          {description && <p className={classes.description}>{description}</p>}
        </div>
      )}
      {plain ? children : children && <div className={classes.card}>{children}</div>}
    </section>
  );
};

export default SettingsSection;
